"use client";
import React, { useEffect, useState } from "react";
import Login from "./login/page";
import { useSearchParams } from "next/navigation";
import { useDispatch } from "react-redux";
import { setLan } from "@/redux/userSlice";

export default function Home() {
  const searchParams = useSearchParams();
  const dispatch = useDispatch();
  const [lanId, setLanId] = useState(searchParams.get('lanid'))

  // useEffect(() => {
  //   if (typeof window !== undefined) {
  //     if (lanId != null) {
  //       dispatch(setLan(lanId));
  //     }
  //     else {
  //       dispatch(setLan(''));
  //     }
  //   }
  // }, []);

  return (
    <Login />
  );
}
